import { createFileRoute } from "@tanstack/react-router";
import BrandConnection from "@/components/BrandConnection";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import BigDates from "@/components/BigDates";

import PrivateAviationFeature from "@/components/PrivateAviationFeature";
import AirportTransport from "@/components/AirportTransport";

import ServicesGrid from "@/components/ServicesGrid";
import ServiceAreas from "@/components/ServiceAreas";
import WhyChoose from "@/components/WhyChoose";
import FleetSection from "@/components/FleetSection";
import Testimonials from "@/components/Testimonials";
import InstagramReels from "@/components/InstagramReels";
import TextMariaSection from "@/components/TextMariaSection";
import FamilyChauffeurs from "@/components/FamilyChauffeurs";
import SuvSection from "@/components/SuvSection";
import SpecializedServicesLinks from "@/components/SpecializedServicesLinks";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import heroImageUrl from "@/assets/sprinter-starlight-blue.jpg?format=webp&quality=72&w=1920&h=1080&fit=cover&imagetools";
import heroImageUrl640 from "@/assets/sprinter-starlight-blue.jpg?format=webp&quality=60&w=640&h=800&fit=cover&imagetools";
import heroImageUrl1024 from "@/assets/sprinter-starlight-blue.jpg?format=webp&quality=65&w=1024&h=768&fit=cover&imagetools";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Sprinter Limo & Luxury Car Service Atlanta | Atlanta Luxury Sprinters" },
      { name: "description", content: "Luxury car service and private car service in Atlanta, chauffeured Mercedes-Benz Sprinter limos for airport and private jet transfers, corporate travel, weddings and nights out. Call (678) 431-7222." },
      { property: "og:title", content: "Sprinter Limo & Luxury Car Service Atlanta | Atlanta Luxury Sprinters" },
      { property: "og:description", content: "Luxury car service and private car service in Atlanta, chauffeured Mercedes-Benz Sprinter limos for airport and private jet transfers, corporate travel, weddings and nights out. Call (678) 431-7222." },
      { property: "og:url", content: "https://atlantaluxurysprinters.com/" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: "https://atlantaluxurysprinters.com/" },
      {
        rel: "preload",
        as: "image",
        href: heroImageUrl,
        imageSrcSet: `${heroImageUrl640} 640w, ${heroImageUrl1024} 1024w, ${heroImageUrl} 1920w`,
        imageSizes: "100vw",
        fetchPriority: "high",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": "https://atlantaluxurysprinters.com/#business",
          name: "Atlanta Luxury Sprinters",
          alternateName: "Empress Elite Limousine",
          image: "https://atlantaluxurysprinters.com/og-image.jpg",
          url: "https://atlantaluxurysprinters.com/",
          telephone: "+1-678-431-7222",
          priceRange: "$$$",
          address: {
            "@type": "PostalAddress",
            streetAddress: "3401 Norman Berry Dr Suite 146",
            addressLocality: "Atlanta",
            addressRegion: "GA",
            postalCode: "30344",
            addressCountry: "US",
          },
          areaServed: [
            { "@type": "City", name: "Atlanta" },
            { "@type": "Place", name: "Buckhead" },
            { "@type": "Place", name: "Midtown Atlanta" },
            { "@type": "Place", name: "Hartsfield-Jackson Atlanta International Airport" },
          ],
          description: "Luxury car service and private car service in Atlanta, Mercedes-Benz Sprinter Limousine transportation for VIP airport transfers, corporate travel, weddings, and group events in Atlanta, GA.",
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "@id": "https://atlantaluxurysprinters.com/#quote-service",
          name: "Sprinter Limousine Quote Request, Atlanta",
          serviceType: "Luxury Sprinter limousine and chauffeur service",
          description:
            "Request a free, no-obligation quote for Mercedes-Benz Sprinter Limousine, executive Sprinter, party bus, and charter bus transportation in Atlanta. Text or WhatsApp (678) 431-7222 with your pickup, drop-off, date and passenger count for pricing and availability.",
          provider: { "@id": "https://atlantaluxurysprinters.com/#business" },
          areaServed: { "@type": "City", name: "Atlanta" },
          offers: {
            "@type": "Offer",
            availability: "https://schema.org/InStock",
            priceCurrency: "USD",
            url: "https://atlantaluxurysprinters.com/#booking",
          },
          potentialAction: {
            "@type": "ReserveAction",
            name: "Request a Quote",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "https://atlantaluxurysprinters.com/#booking",
              inLanguage: "en-US",
              actionPlatform: [
                "https://schema.org/DesktopWebPlatform",
                "https://schema.org/MobileWebPlatform",
              ],
            },
            result: {
              "@type": "Reservation",
              name: "Sprinter limousine quote request",
            },
          },
        }),
      },
    ],

  }),
  component: Index,
});

function Index() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <BrandConnection />
        <FleetSection />
        <SuvSection />
        <TextMariaSection />
        <FamilyChauffeurs />
        <WhyChoose />
        <AirportTransport />
        <PrivateAviationFeature />
        <BigDates />
        <Testimonials />
        <ServicesGrid />
        <InstagramReels />
        <SpecializedServicesLinks />
        <ServiceAreas />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingButtons />
    </>
  );
}
